module.exports = __webpack_public_path__ + "img/trail_of_the_lotus_blossom.33d26b63.png";